'use client';

import React, { useMemo } from 'react';
import { type SearchDefaultData } from '@/app/search/createSearchDefaultData.ts';

export const SearchDefaultDataContext = React.createContext<SearchDefaultData>({} as SearchDefaultData);

export default function SearchDefaultDataProvider({
  searchDefaultData,
  children,
}: {
  searchDefaultData: SearchDefaultData;
  children: React.ReactNode;
}) {
  const contextValue = useMemo(() => searchDefaultData, [searchDefaultData]);
  return <SearchDefaultDataContext.Provider value={contextValue}>{children}</SearchDefaultDataContext.Provider>;
}

export const useSearchDefaultData = () => React.useContext(SearchDefaultDataContext);
